'use client'
import {KennisCentrum} from "./KennisCentrum";
import {SWRConfig} from 'swr'

export const KennisCentrumInit = ({searchParams, kenniscentrumInitData, ingelogdeGebruiker}) => {
    return <SWRConfig value={{ kenniscentrumInitData: kenniscentrumInitData}}><KennisCentrum searchParams={searchParams} ingelogdeGebruiker={ingelogdeGebruiker} /></SWRConfig>
}